import { Pipe, PipeTransform } from '@angular/core';
import { SignatureType } from '../model/signature-type.model';

@Pipe({
  name: 'signatureTypeIcon',
})
export class SignatureTypeIconPipe implements PipeTransform {
  transform(type: SignatureType): string {
    // return icon name
    switch (type) {
      case SignatureType.Hand:
        return 'edit';
      case SignatureType.Email:
        return 'mail_outline';
      case SignatureType.SMS:
        return 'sms';
    }
  }
}
